import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GeneralService } from '../../../@core/data/general.service';
import { LoginService } from '../../../@core/data/login.service';
import { Home } from '../../../@core/models/home';

/**
 * Faixa de consentimento de cookies (ED-2924).
 *
 * Montada global no app.component, e não mais aberta como modal pela tela de
 * login: assim também aparece para quem entra por link direto e cai no login
 * sem passar pela home. Fechar equivale a aceitar — as chaves de gravação são
 * as mesmas de antes, então quem já aceitou não é perguntado de novo.
 */
@Component({
  selector: 'edm-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookieConsentComponent implements OnInit, OnDestroy {

  visible: boolean = false;
  privacy: string;

  pathBaseTranslate: string = 'theme.components.cookie-consent.';

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private loginService: LoginService,
    private generalService: GeneralService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.visible = !this.loginService.isCookieConsent();
    if (!this.visible) return;

    this.generalService.home$
      .pipe(takeUntil(this.destroy$))
      .subscribe((home: Home): void => {
        if (this.exists(home) && this.exists(home.privacy)) {
          this.privacy = home.privacy;
          this.cdr.markForCheck();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  accept(): void {
    this.loginService.consentCookie();
    this.visible = false;
    this.cdr.markForCheck();
  }

  getTranslate(key: string): string {
    return this.generalService.getTranslate(`${this.pathBaseTranslate}${key}`);
  }

  exists(value: Object): boolean {
    return value !== null && value !== undefined && value !== '';
  }
}
